import actions from './actions'

export default function ContractInvoicePartnersReducer(state = { loading: false }, action) {
  switch (action.type) {
    case actions.REQUESTING:
      return {
        ...state,
        loading: true,
        editing: null,
        saveSuccess: false,
      }
    case actions.LIST_CONTRACTINVOICEPARTNER:
      return {
        ...state,
        result: action.result,
        loading: false,
        saveSuccess: false,
      }
    case actions.EDIT_CONTRACTINVOICEPARTNER:
      return {
        ...state,
        editing: action.result,
        loading: false,
        saveSuccess: false,
      }
    case actions.RESET_CONTRACTINVOICEPARTNER:
      return {
        ...state,
        editing: null,
        loading: false,
        saveSuccess: false,
      }
    case actions.NEW_CONTRACTINVOICEPARTNER:
      return {
        ...state,
        editing: { contractInvoicePartnerID: 0 },
        loading: false,
        saveSuccess: false,
      }
    case actions.SAVE_CONTRACTINVOICEPARTNER_RECIEVED:
    case actions.DELETE_CONTRACTINVOICEPARTNER_RECIEVED:
      return {
        ...state,
        editing: { contractInvoicePartnerID: 0 },
        loading: false,
        saveSuccess: true, // mark
      }
    case actions.RESPONSE_ERROR:
      return {
        ...state,
        loading: false,
        error: true,
        saveSuccess: false,
        message: action.message,
      }
    default:
      return state
  }
}
